import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, FilledBar, UnfilledBar, UnfilledBarContainer } from './styles';
const ProgressBar = (_a) => {
    var { percentComplete, filledBackground } = _a, props = __rest(_a, ["percentComplete", "filledBackground"]);
    const percentLeft = 100 - percentComplete;
    return (_jsxs(Container, Object.assign({ role: "progressbar", "aria-valuenow": percentComplete }, props, { children: [_jsx(UnfilledBarContainer, { children: _jsx(UnfilledBar, { percentLeft: percentLeft }) }), _jsx(FilledBar, { filledBackground: filledBackground })] })));
};
export default ProgressBar;
//# sourceMappingURL=index.js.map